<template>
  <div>
    <PageHeader :text="project.name">
      <EditButton label="Редактировать" />
    </PageHeader>

    <ProjectDescription :project="project" />

    <v-data-table
      class="mb-8"
      :headers="headers"
      :items="data"
      item-key="id"
      disable-pagination
      hide-default-footer
      @click:row="onRowClick"
    >
      <template v-slot:[`item.status`]="{ item }">
        <v-progress-linear
          v-model="item.status"
          class="mb-2"
        ></v-progress-linear>
        <div class="d-flex grey--text">
          <div class="mr-2">{{ item.status }}%</div>
          <div v-if="item.status === 100">
            <div v-if="item.done">
              <v-icon class="mr-1">mdi-check-all</v-icon>
              <span>НМИЦ отправил ответы</span>
            </div>
            <div v-else>
              <v-icon class="mr-1" small>mdi-alert</v-icon>
              <span>НМИЦ ответил на все вопросы, но не отправил ответы</span>
            </div>
          </div>
        </div>
      </template>
    </v-data-table>

    <v-checkbox
      v-model="confirm"
      label="Завершить проект и отправить его в архив можно не дожидаясь окончания работы всех НМИЦ. Отметьте, чтобы завершить"
    ></v-checkbox>
    <v-btn color="primary" :disabled="!confirm" @click="onNextStageCLick"
      >Завершить</v-btn
    >
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue'
import EditButton from '@/components/buttons/EditButton.vue'
import ProjectDescription from '@/components/project/ProjectDescription.vue'

import { toNextStage } from '@/lib/requestsAPI'
import { calculatePercent } from '@/lib/percent.js'

import { routeParams } from '@/mixins/routeParams'
import { sendDataWithToastNoRedirect } from '@/mixins/sendDataWithToastNORedirect'

import { ADMIN, PROJECTS, PROJECT_SHORT, USER_PR_NOS } from '@/store/const/path'
import { USER_NMIC_ID } from '@/store/const/userRoles'

export default {
  data() {
    return {
      confirm: false,
      headers: [
        { text: 'КР', value: 'nosologiaName' },
        { text: 'НМИЦ', value: 'nmicFIO' },
        { text: 'Готовность', value: 'status' },
      ],
    }
  },
  props: ['project'],
  components: {
    PageHeader,
    ProjectDescription,
    EditButton,
  },
  mixins: [routeParams, sendDataWithToastNoRedirect],
  computed: {
    nosologies() {
      return this.project.projectNosologies
    },
    projectUsers() {
      return this.project.users
    },
    data() {
      const preparedData = []
      this.nosologies.forEach(nos => {
        const nosologiaName = nos.nosology.name
        nos.userProjectNosologies.forEach(upn => {
          if (upn.user.role_id === USER_NMIC_ID) {
            preparedData.push({
              nosologiaName,
              id: upn.id,
              nmicFIO: upn.user.fio,
              done: upn.is_completed,
              status: calculatePercent(
                upn.answered_criteria_count,
                upn.common_criteria_count
              ),
            })
          }
        })
      })
      return preparedData
    },
  },
  methods: {
    onNextStageCLick() {
      this.sendDataWithToastNoRedirect({
        action: toNextStage,
        data: this.projectId,
        successMessage: 'Отправлен в работу',
        errorMessage: 'Ошибка отправки в работу',
        onSuccess: () => this.throwUpdate(),
      })
    },
    throwUpdate() {
      this.$emit('update')
    },
    onRowClick(item) {
      this.$router.push(
        `/${ADMIN}/${PROJECTS}/${PROJECT_SHORT}-${this.project.id}/${USER_PR_NOS}-${item.id}`
      )
    },
  },
}
</script>

<style scoped>
.v-data-table {
  cursor: pointer;
}
</style>
